import React,{useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import './CustomDialog.scss'

const CustomDialog = () => {
  const dialog = useSelector(state => state.auth.dialog)
  const url = useSelector(state => state.auth.dialog.redirctUrl)
  const [open, setOpen] = useState(true)
  const handleClose = () => {
    setOpen(false);
    window.location.replace(url);
  };

  return (
    <Dialog
      open={open}
      className="general-dialog"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <div className="dialog-content">
        {
          dialog.category === 'information'?
          <img className="dialog-icon" alt="icon" src="/images/icon-information.svg"></img>
          :
          <img className="dialog-icon" alt="icon" src="/images/icon-error.svg"></img>

        }
        <p>{dialog.message}</p>
        <Button variant="contained" className="btn-dialog"  onClick={handleClose}>
          OK
        </Button>
      </div>

    </Dialog >
  )
}

export default CustomDialog;